import React from 'react'
import Routes from './Routes'
import 'babel-polyfill';

export default () => (
    <Routes />
)


// WEBPACK FOOTER //
// ./src/app/routes/App.js